import { SectionLoader } from '@/shared/components/section-loader';

export const AdminRecordsLoading = () => {
  return <SectionLoader />;
};
